module.exports = __webpack_public_path__ + "webpc/img/icon_top_bg.1004b8da.png";